import Model, { belongsTo } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";
import type TherapeuticalArea from "./therapeutical-area";
export default class FollowUpReason extends Model {
  @belongsTo("therapeutical-area", { async: false, inverse: "followUpReasons" })
  declare therapeuticalArea: TherapeuticalArea;

  #specificAdverseEvents: ModelRegistry["adverse-event"][] = [];

  get patho(): string {
    return this.id.split("-").splice(1).join("-");
  }

  get adverseEvents(): ModelRegistry["adverse-event"][] {
    if (this.#specificAdverseEvents.length > 0) {
      return this.#specificAdverseEvents;
    }
    return this.therapeuticalArea.adverseEvents.slice();
  }

  set adverseEvents(array: ModelRegistry["adverse-event"][]) {
    this.#specificAdverseEvents = array;
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "follow-up-reason": FollowUpReason;
  }
}
